import {
  genesisUUID,
} from '../utils/uuid'

export interface GenesisSession {
  conversationSessionId: string
  engineeringSessionId?: string
  updatedAt: string
}

const STORAGE_KEY =
  'sei-genesis-vnext-session'

const CHANNEL =
  'sei-genesis-vnext-channel'

export function createSession():
GenesisSession {
  return {
    conversationSessionId:
      `conversation-${genesisUUID()}`,
    updatedAt:
      new Date().toISOString(),
  }
}

export function loadSession():
GenesisSession {
  const raw =
    localStorage.getItem(
      STORAGE_KEY,
    )

  if (raw) {
    try {
      return JSON.parse(
        raw,
      ) as GenesisSession
    } catch {
      // Create a clean session below.
    }
  }

  const session =
    createSession()

  saveSession(session)

  return session
}

export function saveSession(
  session: GenesisSession,
) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(session),
  )

  if (
    'BroadcastChannel'
    in window
  ) {
    const channel =
      new BroadcastChannel(
        CHANNEL,
      )

    channel.postMessage(
      session,
    )

    channel.close()
  }
}

export function openLAIAWindow(
  sessionId: string,
) {
  const url =
    new URL(
      window.location.href,
    )

  url.searchParams.set(
    'view',
    'laia',
  )

  url.searchParams.set(
    'session',
    sessionId,
  )

  window.open(
    url.toString(),
    'SEI_LAIA_GENESIS',
    'popup=yes,width=1100,height=900,resizable=yes,scrollbars=yes',
  )
}
